export default class Bitmap {
  context: CanvasRenderingContext2D;

  constructor(context: CanvasRenderingContext2D) {
    this.context = context;
  }

  hline(y: number, x: number, d: number, color: string) {
    this.context.beginPath();
    this.context.strokeStyle = color;
    this.context.lineWidth = 1;

    const x1 = Math.round(x);
    const y1 = Math.round(y);
    const x2 = Math.round(x + d);
    this.context.moveTo(x1, y1);
    this.context.lineTo(x2, y1);
    this.context.stroke();
  }

  vline(x: number, y: number, d: number, color: string) {
    this.context.beginPath();
    this.context.strokeStyle = color;
    this.context.lineWidth = 1;

    const x1 = Math.round(x);
    const y1 = Math.round(y);
    const y2 = Math.round(y + d);
    this.context.moveTo(x1, y1);
    this.context.lineTo(x1, y2);
    this.context.stroke();
  }

  putPel(x: number, y: number, color: string) {
    this.context.beginPath();
    this.context.fillStyle = color;
    this.context.fillRect(x, y, 1, 1);
  }

  drawShape(points: number[], color: string) {
    this.context.beginPath();

    this.context.moveTo(Math.round(points[0]), Math.round(points[1]));
    this.context.fillStyle = color;

    this.context.strokeStyle = "transparent";
    this.context.lineWidth = 0;
    for (let i = 1; i < points.length / 2; i++) {
      this.context.lineTo(
        Math.round(points[i * 2]),
        Math.round(points[i * 2 + 1])
      );
    }

    this.context.closePath();
    this.context.fill();
  }

  drawRoundedRect(x: number, y: number, width: number, height: number, radius: number, color: string) {
    this.context.beginPath();
    this.context.fillStyle = color;
    
    const rx = Math.round(x);
    const ry = Math.round(y);
    const rw = Math.round(width);
    const rh = Math.round(height);
    const r = Math.max(0, Math.min(radius, Math.min(rw / 2, rh / 2)));

    // Top-left corner
    this.context.moveTo(rx + r, ry);
    // Top edge
    this.context.lineTo(rx + rw - r, ry);
    // Top-right corner
    this.context.arc(rx + rw - r, ry + r, r, -Math.PI / 2, 0, false);
    // Right edge
    this.context.lineTo(rx + rw, ry + rh - r);
    // Bottom-right corner
    this.context.arc(rx + rw - r, ry + rh - r, r, 0, Math.PI / 2, false);
    // Bottom edge
    this.context.lineTo(rx + r, ry + rh);
    // Bottom-left corner
    this.context.arc(rx + r, ry + rh - r, r, Math.PI / 2, Math.PI, false);
    // Left edge
    this.context.lineTo(rx, ry + r);
    // Top-left corner
    this.context.arc(rx + r, ry + r, r, Math.PI, -Math.PI / 2, false);
    
    this.context.closePath();
    this.context.fill();
  }

  /**
   * Draws an image at the specified position and size
   * @param image - HTMLImageElement or HTMLCanvasElement to draw
   * @param x - X coordinate
   * @param y - Y coordinate
   * @param width - Width to draw (defaults to image width)
   * @param height - Height to draw (defaults to image height)
   */
  drawImage(
    image: HTMLImageElement | HTMLCanvasElement,
    x: number,
    y: number,
    width?: number,
    height?: number
  ): void {
    const rx = Math.round(x);
    const ry = Math.round(y);
    
    if (width !== undefined && height !== undefined) {
      const rw = Math.round(width);
      const rh = Math.round(height);
      this.context.drawImage(image, rx, ry, rw, rh);
    } else {
      this.context.drawImage(image, rx, ry);
    }
  }
}
